var _path, _path2, _path3, _rect, _path4, _path5, _path6, _rect2, _path7, _path8, _path9, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCheckboxGroup = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 120,
  height: 72,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "var(--hop-neutral-surface-selected)",
  d: "M.5 4A3.5 3.5 0 0 1 4 .5h8A3.5 3.5 0 0 1 15.5 4v8a3.5 3.5 0 0 1-3.5 3.5H4A3.5 3.5 0 0 1 .5 12z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "var(--hop-neutral-surface-selected)",
  d: "M.5 4A3.5 3.5 0 0 1 4 .5h8A3.5 3.5 0 0 1 15.5 4v8a3.5 3.5 0 0 1-3.5 3.5H4A3.5 3.5 0 0 1 .5 12z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--hop-neutral-icon-selected)",
  fillRule: "evenodd",
  d: "M12.275 4.646a.58.58 0 0 1 .022.82L7.081 10.97a.58.58 0 0 1-.83.012L3.353 8.085a.58.58 0 1 1 .82-.82l2.476 2.477 4.807-5.074a.58.58 0 0 1 .82-.022Z",
  clipRule: "evenodd"
})), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 88,
  height: 4,
  x: 32,
  y: 6,
  fill: "var(--hop-neutral-border-weak)",
  rx: 2
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--hop-neutral-surface-selected)",
  d: "M.5 32A3.5 3.5 0 0 1 4 28.5h8a3.5 3.5 0 0 1 3.5 3.5v8a3.5 3.5 0 0 1-3.5 3.5H4A3.5 3.5 0 0 1 .5 40z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  stroke: "var(--hop-neutral-surface-selected)",
  d: "M.5 32A3.5 3.5 0 0 1 4 28.5h8a3.5 3.5 0 0 1 3.5 3.5v8a3.5 3.5 0 0 1-3.5 3.5H4A3.5 3.5 0 0 1 .5 40z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--hop-neutral-icon-selected)",
  fillRule: "evenodd",
  d: "M12.275 32.646a.58.58 0 0 1 .022.82L7.081 38.97a.58.58 0 0 1-.83.012l-2.898-2.898a.58.58 0 0 1 .82-.82l2.476 2.477 4.807-5.074a.58.58 0 0 1 .82-.022Z",
  clipRule: "evenodd"
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  width: 88,
  height: 4,
  x: 32,
  y: 34,
  fill: "var(--hop-neutral-border-weak)",
  rx: 2
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--hop-neutral-surface-selected)",
  d: "M.5 60A3.5 3.5 0 0 1 4 56.5h8a3.5 3.5 0 0 1 3.5 3.5v8a3.5 3.5 0 0 1-3.5 3.5H4A3.5 3.5 0 0 1 .5 68z"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  stroke: "var(--hop-neutral-surface-selected)",
  d: "M.5 60A3.5 3.5 0 0 1 4 56.5h8a3.5 3.5 0 0 1 3.5 3.5v8a3.5 3.5 0 0 1-3.5 3.5H4A3.5 3.5 0 0 1 .5 68z"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--hop-neutral-icon-selected)",
  fillRule: "evenodd",
  d: "M12.275 60.646a.58.58 0 0 1 .022.82L7.081 66.97a.58.58 0 0 1-.83.012l-2.898-2.898a.58.58 0 0 1 .82-.82l2.476 2.477 4.807-5.074a.58.58 0 0 1 .82-.022Z",
  clipRule: "evenodd"
})), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
  width: 88,
  height: 4,
  x: 32,
  y: 62,
  fill: "var(--hop-neutral-border-weak)",
  rx: 2
})));
export default SvgCheckboxGroup;